<div class="grid">
	<div class="col-12">
		<p-table #deviceFilesList dataKey="id" [value]="files" [lazy]="true" (onLazyLoad)="loadFiles($event)"
			[paginator]="true" [totalRecords]="totalRecords" [loading]="filesLoading" [rows]="pageSize"
			[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
			sortField="created_at" [sortOrder]="-1" responsiveLayout="stack">

			<ng-template pTemplate="header">
				<tr>
					<th>
						<div pSortableColumn="name" class="flex align-items-center justify-content-center">
							{{ 'NAME' | translate }}
							<p-sortIcon field="name"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="created_at" class="flex align-items-center justify-content-center">
							{{ 'CREATED_AT' | translate }}
							<p-sortIcon field="created_at"></p-sortIcon>
						</div>
					</th>
					<!-- <th>
						<div pSortableColumn="updated_at" class="flex align-items-center justify-content-center">
							{{ 'UPDATED_AT' | translate }}
							<p-sortIcon field="updated_at"></p-sortIcon>
						</div>
					</th> -->
					<th>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-file>
				<tr>
					<td>
						<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>{{file.Name}}
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'CREATED_AT' | translate }}</span>{{file.CreatedAt |
						localizedDate: 'medium'}}
					</td>
					<!-- <td>
						<span class="p-column-title font-semibold">{{ 'UPDATED_AT' | translate }}</span>{{file.UpdatedAt |
						localizedDate: 'medium'}}
					</td> -->
					<td>
						<span class="p-column-title font-semibold">
						</span>
						<div class="flex flex-row justify-content-center align-items-center gap-1">
							<p-button [disabled]="taskRunning || offline" label="{{'IMPORT_LIST' | translate }}"
								tooltipPosition="bottom" icon="pi cm-cloud-arrow-down" size="large" (click)="importList(file)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<p-button pTooltip="{{ 'EDIT_NAME' | translate }} {{ ('LIST' | translate).toLowerCase() }}"
								tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="editListFile(file)"
								[rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'DELETE_LIST' | translate }}" tooltipPosition="bottom" icon="pi cm-trash"
								size="large" (click)="deleteListFile(file)" [rounded]="false" [text]="true" severity="danger">
							</p-button>
						</div>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!-- <p-confirmDialog #delListConfDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="delListConfDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="delListConfDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="delListConfDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="delListConfDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog> -->